import BustWithPaper from '../../../public/images/busts/bustWithPaper.svg';
import styles from '../../../styles/modules/promotion/referral/ReferralInstruction.module.scss';

const ReferralInstruction = () => {
  return (
    <section className="block">
      <div className="fixed">
        <div className={styles.instruction}>
          <h3>Как пригласить друга</h3>
          <div className={styles.instructionContent}>
            <BustWithPaper className={styles.instructionImage} />
            <div className={styles.instructionSteps}>
              <div className={styles.instructionStepsItem}>
                <div className={styles.instructionStepsItemNumber}>1</div>
                <div className={styles.instructionStepsItemContent}>
                  <div className={styles.instructionStepsItemContentTitle}>Получить ссылку</div>
                  <div className={styles.instructionStepsItemContentDescription}>
                    все просто, есть только одно условие – быть клиентом «ЛЕНДЛОРД» и получить
                    SMS-сообщение
                  </div>
                </div>
              </div>
              <div className={styles.instructionStepsItem}>
                <div className={styles.instructionStepsItemNumber}>2</div>
                <div className={styles.instructionStepsItemContent}>
                  <div className={styles.instructionStepsItemContentTitle}>Поделиться с другом</div>
                  <div className={styles.instructionStepsItemContentDescription}>
                    отправь ссылку из SMS-сообщения другу: в соцсети, мессенджеры или на электронную
                    почту
                  </div>
                </div>
              </div>
              <div className={styles.instructionStepsItem}>
                <div className={styles.instructionStepsItemNumber}>3</div>
                <div className={styles.instructionStepsItemContent}>
                  <div className={styles.instructionStepsItemContentTitle}>Получить деньги</div>
                  <div className={styles.instructionStepsItemContentDescription}>
                    в кассе главного офиса <span className={styles.bold}>до 5 000 ₽</span> за
                    каждого, кто подпишет договор с «ЛЕНДЛОРД» на определенный вид услуги
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReferralInstruction;
